import { useEffect } from "react";
import { CONTENT_TABS, getPrimaryContentStatIdForTab } from "../components/content/contentData";

const VALID_TAB_IDS = new Set(CONTENT_TABS.map((tab) => tab.id));

export default function useContentRouteTab(search, setActiveTab, setContentStatFilterId) {
  // Apply incoming navigation once; local selections must not reapply the URL tab.
  useEffect(() => {
    const requestedTab = new URLSearchParams(search).get("tab");
    if (!VALID_TAB_IDS.has(requestedTab)) return;
    setActiveTab(requestedTab);
    setContentStatFilterId(getPrimaryContentStatIdForTab(requestedTab));
  }, [search, setActiveTab, setContentStatFilterId]);
}
